import React, { useMemo } from "react";
import GameDesk from "../catalog_game/games-desk/GameDesk";
import "./favorites.scss";
import { useSelector } from "react-redux";
import ShowContainer from "../../mui/ShowContainer";
import { getSliceForCarousel } from "../../../utils/utils";
import useFillFavorites from "../../../hooks/common/useFillFavorites";
import { GAME_COUNT } from "../../../store/enums";

export default function Favorites() {
  useFillFavorites(GAME_COUNT);
  const favoritesS = useSelector((state) => state.games.favoriteGames);
  const favorites = useMemo(() => getSliceForCarousel(favoritesS), [favoritesS]);
  const isAuth = useSelector((state) => state.user.isAuth);

  return (
    <ShowContainer condition={favorites.length && isAuth}>
      <section className="favorites">
        <div className="favorites__content">
          <GameDesk
            id={"favorites"}
            showAllLink={"/games/favorites"}
            title={"Favorites"}
            items={favorites}
          />
        </div>
      </section>
    </ShowContainer>
  );
}
